"use client";
function e() {
  return typeof window > "u";
}
export {
  e as isSSR
};
